module.exports = __webpack_public_path__ + "media/images/athletes/2916-676aed3b02deb384e008110d4c714eb9.png";